/* globals FB */
;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  // var url = window.location

  eah.fbShare = (function () {
    const initialize = function () {
      $('.chiclet .facebook').on('click', function (e) {
        e.preventDefault()

        const url = window.href

        window.console && console.log('fb share!', url)
        FB.ui({
          method: 'share',
          href: url
        }, function (response) {
          window.console && console.log('shared!')
        })
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    // eah.fbShare.initialize();
  })
}(jQuery, window))
